import React from 'react'
import $ from 'jquery'
import './style.css'

import { WritableStream } from 'web-streams-polyfill/ponyfill'
import streamSaver from 'streamsaver'

import feat1 from './assets/feat1.svg'
import feat2 from './assets/feat2.svg'
import loading from './assets/loading.gif'

/**
 * fetch axios流处理下载，等待文件流下载到内存才会弹出浏览器下载文件保存对话框。
 * 解决StreamSaver+Fetch,在chrome运行良好，Firefox 或 Safari 支持不佳，引入web-streams-polyfill适配
 * axios等文件流下载完了才有响应，比较适合restful的场景。 
 * rocket-loader 前端优化工具，用于解决加载速度慢的问题。
 */

class DownloaderApp extends React.Component{
    constructor(props){
        super(props);
        this.state={
          url: '',
          type: '',
          isClicked: false
        };
    }
    urlUpdater=(event)=>{
        this.setState({url:event.target.value});
    }
    typeUpdater=(event)=>{
        this.setState({type:event.target.value});
    }
    pasteUrl= (event) => {
        /*navigator.clipboard.readText().then((text) => {
            this.setState({url: text});
          }, () => {
            console.log('Paste failed');
          });*/
        var text = window.NativeAndroid.pasteFromClipboard();
        this.setState({url: text});
        //prevent form submit
        event.preventDefault();
    }
    submitForm=(event)=>{
        //prevent form submit
        event.preventDefault();
        var media = this.state.type;

        //wyl
        var params = new URLSearchParams();
        params.append("url",this.state.url);
        //ajax fetch axios比较
        
        /*$.ajax({
            url:"https://y1.youtube-to-mp3.org/searchdl.php",                  
            method:"POST",
            data:{
                "type":this.state.type,
                "url":this.state.url
            },
            data:params,
            processData: false,
            contentType: false,
            headers:{"Content-Type":"application/x-www-form-urlencoded"},
            success:function(data){
                $("#data").html(data);                               
                var doc=document.createElement('html');
                setStyle(media);
                doc.innerHTML=data;               
            },
            error:function(XMLHttpRequest,textStatus,errorThrown){  
                $("#data").text(textStatus)              
            }
        });*/

        this.download_app(this.state.url);  

        function setStyle(type){
            $('.y_thumb').attr("class","y_thumb col-sm-12 col_md_12 col_xs_12");
            $('.title').attr('style','font-size:20px;padding:5px;margin:5px;font-weight:600;');
            $('.tab-inner').html("");
            $('#tab_video').attr('style','margin:5px;padding:5px;');
            $('#tab_video').attr('class','table');
            $('#tab_mp3').attr('style','margin:5px;padding:5px;');
            $('#tab_mp3').attr('class','table table-striped');
            $('.btn-sm').attr('style','background-color:rgb(255,0,0);border:none');
            if(type==="mp3"){
              $('#tab_video').html("");
              $('#formbox').hide();
            }
            if(type==="mp4"){
              $('#tab_mp3').html("");
              $('#formbox').hide();
            }
        } 
   
    }

    isValidLink = (url) => {
        const urlReg = /^.*((https?|ftp|file):\/\/)?([\da-z\.-]+)\.([a-z\.]{2,6})([\/\w \.-]*)*\/?.*$/;
        return urlReg.test(url); 
    }

    download_app = (url) => {
        $(".alert").addClass("show-search");
        try{
            //在submitForm内部定义的函数无法读取this.state属性, undefined
            console.info('hello')
        }
        catch(error){
            alert(error);
        }
        //response 302，重定向response location,浏览器jquery不允许修改User-Agent.
        if(!this.isValidLink(url)){
            $(".alert").removeClass("show-search");   
            return;
        }

        this.setState({isClicked:true},()=>{
            //alert(this.state.isClicked);
            //enter http request here
        });

        $(".loading").toggleClass("show-search");
        //回调函数没有绑定this，需要提前赋值
        var that = this;
        window.WebViewJavascriptBridge.callHandler(
            'download',
            {
                'server': 'https://douyin.yueyutian.com/ecs/downloadInfo',
                'url': url
            },
            function(responseData){
                $(".loading").toggleClass("show-search");
                that.setState({isClicked:false},() =>{
                    //alert(that.state.isClicked);
                })
            }
        );       
    }

    download = (url) => {
        $(".alert").addClass("show-search");
        //response 302，重定向response location,浏览器jquery不允许修改User-Agent.
        if(!this.isValidLink(url)){
            $(".alert").removeClass("show-search");
            return;
        }

        var params = new URLSearchParams();
        params.append("url",url);
        
        var filename = '';

        fetch("https://douyin.yueyutian.com/ecs/downloadPath",{
            method: 'POST',
            withCredentials: true,
            headers: {'Content-Type':'application/x-www-form-urlencoded'},    
            body: params,                
        }).then(resp => {
            //$("#data").text('downloading...')
            console.log('loading...')
            $(".loading").toggleClass("show-search");
            //Extract filename from header               
            filename = resp.headers.get('Content-Disposition')
                .split(';')
                .find(n => n.includes('filename='))
                .replace('filename=','')
                .trim();
            const length = resp.headers.get('content-length');
            
            //If the WritableStream is not available (Firefox, Safari)
            if(!window.WritableStream){
                console.log('no WritableStream');                   
                streamSaver.WritableStream = WritableStream;                    
                console.log(window.WritableStream);             
            }

            const filestream = streamSaver.createWriteStream(filename,{
                size: length});  
           
            const readablestream = resp.body;
            if(window.WritableStream && readablestream.pipeTo){                   
                return readablestream.pipeTo(filestream).then(() => {
                    //$("#data").text('downloading finished!')
                    $(".loading").toggleClass("show-search");
                    console.log('downloading finished!');
                });
            }
            else if(!window.WritableStream){
                window.writer = filestream.getWriter();
                
                const reader = resp.body.getReader();              
                const pump = () => reader.read().then(res => {                  
                    if(res.done){
                        window.writer.close();                                                        
                        $(".loading").toggleClass("show-search")    
                        console.log('finished');                 
                    }
                    else{
                        window.writer.write(res.value).then(pump);
                    }                                      
                });

                pump();
            }
            
            //原始数据的类文件object
            //return resp.blob();
        })           
        /*.then(blob => {
            //等待整个文件流下载到内存
            const url = window.URL.createObjectURL(blob);               
            const a = document.createElement('a');   
            a.style.display = 'none';                               
            a.href = url;
            a.download = filename;
            document.body.appendChild(a);                
            a.click();
            document.body.removeChild(a);
            window.URL.revokeObjectURL(url);
            
        })*/
        .catch(error => {
            console.log(error);
            alert(error);
        });
    }

    render(){
        return(
            <div /*className="mx-auto"*/>   
                <div className='ftco-section' /*style={{height:'auto !important;'}}*/>            
                    <div className="container">
                        {/*<div className="row justify-content-center">*/}
                            <h1 className='title'>视频下载</h1>
                            <p>在线免费下载无水印视频</p>
                            <form id="formbox" className="search-form relative"/*"box"*/ role="search">
                                {/*<div className="col-sm-8 col-xs-12 col-md-12">*/}
                                    {/*<div className="form-group">*/}
                                        <input type='search'/*'text'*/ value={this.state.url} onChange={this.urlUpdater} className="search-input"/*'form-control'*/
                                            autoComplete='off' placeholder='在此粘贴链接'/>
                                        <button className='btn-red' type='button' onClick={this.pasteUrl} ><span>粘贴链接</span></button>    
                                        <button className='btn-red' type='button' onClick={this.submitForm} ><span>开始</span></button>    
                                    {/*</div>*/}
                                    {/*
                                    <div className="form-group">
                                        <label>Type</label>
                                        <select onChange={this.typeUpdater} className='form-control'>
                                            <option value="">--Select Download Type--</option>
                                            <option value="mp3">MP3</option>
                                            <option value="mp4">MP4</option>
                                        </select>
                                    </div>
                                    */}
                                    {/*
                                    <div className="form-group">
                                        <button className='btn btn-success' type='button' onClick={this.submitForm} ><span>开始</span></button>
                                    </div>
                                    */}
                                {/*</div>*/}
                            </form>
                            <div id="result_container" className='clearfix'>
                                <div className='loading show-search text-center mt-5 mb-5'>
                                    <img alt="loading" className='mb-2' src={loading}/>
                                    <p>正在转换，请稍候...</p>
                                </div>
                                <div className='alert show-search alert-danger text-center mt-4' role='alert'>
                                    <span>无效的视频链接，请稍候再试</span>
                                </div>
                            </div>
                            <div className="databox mx-auto col-md-12  justify-content-center">
                                <div id='data'></div>
                            </div>
                            <h2 className="water">下载没有水印的视频</h2>
                            <p className="water-content">
                                "该应用为一款在线网络工具，可帮助您下载无水印的 dou音、头tiao 视频。您可以下载任意数量的 MP4 或 MP3 格式的 dou音 视频，同时保持与原始视频相同的质量。 旨在易于在任何设备上使用，例如手机、计算机或平板电脑。" 
                            </p> 
                            <p classsName="water-content">
                                "下载完请到相册查看。"
                            </p>               
                        {/*</div>*/}
                    </div>
                </div>
                <div className='feature-list'> 
                    <div className='container'>
                        <h2 className='title'>特点</h2>
                        <ul className='list'>
                            <li>
                                <img width='80px' height='80px' alt='feature 1' src={feat1}/>
                                <div className="clearfix">
                                    <span>无水印</span>
                                    <span>下载的视频没有水印，可以编辑或离线观看。</span>
                                    
                                </div>
                                
                            </li>
                            <li>
                                <img width='80px' height='80px' alt='feature 2' src={feat2}/>
                                <div className="clearfix">
                                    <span>免费且无限制</span>
                                    <span>免费下载任意数量的视频和音频。</span>
                                    
                                </div>
                                
                            </li>
                        </ul>
                    </div>
                </div>
            </div>           
        );
    }
}
export default DownloaderApp;

/**
 * 常见library:
 * dowloadjs 支持URL FILE BLOB
 * file-saver   支持URL FILE BLOB
 * streamsaver 支持大文件download
 * 
 * 其他下载:
 * A标签
 * iframe下载
 * Form表单下载
 * 
 * index.html 注册JS事件监听 WebViewJavascriptBridge
 * 
 * React组件与内部function的关系, this指组件。不能this.内部function
 * 
 * React组件的this内部指向问题：
 * 1 在构造函数使用bind,绑定function,例如 a()
 * 2 将箭头函数赋值给类的属性
 * 第一种效率更高
 */